import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VAutocomplete,_vm._b({attrs:{"outlined":"","items":_setup.itens,"error-messages":_setup.mensagem},model:{value:(_setup.VALOR_MODEL_COMPUTED),callback:function ($$v) {_setup.VALOR_MODEL_COMPUTED=$$v},expression:"VALOR_MODEL_COMPUTED"}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }